export interface Violation {
    id: string;
    message: string;
    path: string;
}

export const equal = (a: Violation[], b: Violation[]): boolean =>
    a.length === b.length && a.every(
        (val, index) => val.id === b[index].id
    );
